import {
  ProjectExperiments,
  SessionExperiments,
  UserExperiments,
} from '../experiments';

export const sessionExperiments: Partial<SessionExperiments> = {
  'T240666-webapp-home-page-redesign-v8.1': 'control',
  'T245387-hire-a-freelancer-landing-page-v1': 'control',
  'T249395-find-page-redesign': 'control',
};

export const userExperiments: Partial<UserExperiments> = {
  'T250145-invite-from-freelancer-directory': 'test',
  'T248603-new-default-bid-amount': 'control',
  'T246140-user-search-result-card-v1': 'test',
  'T111865-logged-in-pjp-live-chat-just-enrollment': 'control',
  'T58186-giveget-delayed-payment-verify-v2': 'control',
  'T90189-image-thumbnail-service': 'control',
  'T178308-freelancer-my-projects-empty-state-V2': 'control',
  'T221621-fixed-initial-payment-v3': 'control',
  'T237267-pjp-swap-hourly-and-fixed-project-positions': 'control',
  'TNS-T247885-require-payment-verification-new-user': 'test',
  'T233747-charge-project-fee-on-award': 'control',
  'MSG-T206517-redesign-messaging': 'control',
  webapp_playground_test: 'control',
};
export const projectExperiments: Partial<ProjectExperiments> = {};

export const isWhitelistUser = false;

export const shouldEnrol = true;
